/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Pagination, Table } from 'antd';
import tableColumns from './tableColumns';
import UserContext from '../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../custom-hooks/useCustomApiRequest';
import PaymentDepartmentContext from '../../contexts/payment-departments-context/PaymentDepartmentContext';
import getAllDepartments from '../../apis/payment-departments/getAllDepartments';
import { useTranslation } from 'react-i18next';
// const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const PageTable = () => {
  const {
    isLoading,
    setIsLoading,
    setModalOpened,
    fetchCount,
    setFetchCount,
    allFetchedDepartments,
    setAllFetchedDepartments,
    tablePagination,
    setTablePagination,
    setSelectedDepartment
  } = useContext(PaymentDepartmentContext);
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const [tableDataSource, setTableDataSource] = useState([]);

  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id
    }));
  };

  const customApiRequest = useCustomApiRequest();
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setIsLoading(true);

      customApiRequest(
        getAllDepartments(user?.token || user?.employee?.token, {
          page: tablePagination.current_page
        }),
        (res) => {
          setIsLoading(false);
          if (res?.status === 200 && res?.data?.data?.data?.length >= 0) {
            const data = res?.data?.data?.data;
            setAllFetchedDepartments(data);

            if (res?.data?.data?.pagination) {
              setTablePagination(res.data.data.pagination);
            }
          }
        },
        (error) => {
          setIsLoading(false);
        }
      );
    }
    return () => {
      isMounted = false;
    };
  }, [fetchCount]);

  // map all data to dataSource
  useEffect(() => {
    let isMounted = true;
    if (allFetchedDepartments?.length >= 0) {
      if (isMounted) {
        setTableDataSource(mapDataSource(allFetchedDepartments));
      }
    }

    return () => {
      isMounted = false;
    };
  }, [fetchCount, allFetchedDepartments, allFetchedDepartments?.length]);

  return (
    <>
      <Table
        // pagination={{ defaultPageSize: 5, hideOnSinglePage: true }}
        pagination={false}
        className="antd-custom-table"
        dataSource={tableDataSource}
        columns={tableColumns(
          allFetchedDepartments,
          setSelectedDepartment,
          setIsLoading,
          setModalOpened,
          setFetchCount,
          t,
          user?.token || user?.employee?.token
        )}
        loading={isLoading}
        // scroll={{ x: 400 }}
        footer={false}
      />

      {tablePagination && (
        <Pagination
          style={{ display: 'flex', justifyContent: 'center' }}
          defaultCurrent={1}
          current={tablePagination.current_page}
          pageSize={tablePagination.per_page}
          total={tablePagination.total}
          // itemRender={itemRender}

          onChange={(page, pageSize) => {
            setTablePagination({ ...tablePagination, current_page: page });
            // setTablePagination(...tablePagination , {current_page:page})
            setFetchCount((prev) => prev + 1);
          }}
          hideOnSinglePage={true}
        />
      )}
    </>
  );
};

export default PageTable;
